import { render, staticRenderFns } from "./NewFIR.vue?vue&type=template&id=44b53568"
import script from "./NewFIR.vue?vue&type=script&lang=js"
export * from "./NewFIR.vue?vue&type=script&lang=js"
import style0 from "./NewFIR.vue?vue&type=style&index=0&id=44b53568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports